export default {
    url: '/applicationlog',
    template: '<manage-logs-applicationlog></manage-logs-applicationlog>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/logs/applicationlog/index.js